import { html, nothing } from "lit-html";
import { translate } from "@escapio/shared/l10n/translate";
import { formatRangeToDE } from "@escapio/shared/l10n/date";
import { travelData } from "@escapio/portal/state/travelData";

export const formatDealDateRange = deal =>
	formatRangeToDE(new Date(deal.date_start), new Date(deal.date_end));

export const dealTemplate = (
	ctaLabel,
	deal,
	ctaEventCategory,
	ctaEventActionPrefix,
	ctaEventLabel,
) => {
	return html` <div class="deal__description">
			<strong class="deal__description__header">
				<i class="fa fa-tags"></i> ${translate("deals_list_deal_headline")}
			</strong>
			<div>${deal.text}</div>
		</div>
		<div class="deal__offer">
			<div class="deal__price-container">
				<div class="deal__price">
					${deal.prices?.[travelData.currency]?.originalPrice
						? html`<span class="deal__original-price">
								${deal.prices[travelData.currency].originalPrice}
							</span>`
						: nothing}
					<span>
						${deal.isMinPrice
							? html`<small>${translate("basic_from")} </small>`
							: nothing}
						${deal.prices[travelData.currency].price}
					</span>
				</div>
				<span class="deal__offer-condition">${deal.conditions}</span>
			</div>
			${ctaEventCategory && ctaEventActionPrefix && ctaEventLabel
				? html`<esc-click-tracker
						category="${ctaEventCategory}"
						action="${ctaEventActionPrefix} - ${formatDealDateRange(deal)}"
						label="${ctaEventLabel}"
					>
						<a
							class="action-button deal__cta"
							href="${deal.url}"
							target="_blank"
							rel="noopener noreferrer"
							>${ctaLabel}</a
						>
					</esc-click-tracker>`
				: html`<a
						class="action-button deal__cta"
						href="${deal.url}"
						target="_blank"
						rel="noopener noreferrer"
						>${ctaLabel}</a
					>`}
		</div>`;
};
